/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ares_Legal_Form_205Inputs */

const cs_ares_legal_form_205 = /** @type {(inputs: Ares_Legal_Form_205Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Družstvo`)
};

const en_ares_legal_form_205 = /** @type {(inputs: Ares_Legal_Form_205Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cooperative`)
};

/**
* | output |
* | --- |
* | "Cooperative" |
*
* @param {Ares_Legal_Form_205Inputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ares_legal_form_205 = /** @type {((inputs?: Ares_Legal_Form_205Inputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ares_Legal_Form_205Inputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ares_legal_form_205(inputs)
	return cs_ares_legal_form_205(inputs)
});